/* eslint-disable no-undef */
// @ts-nocheck

import { phoneFormatter } from 'merchant/services/Helper.service';

let commonAnalyticsData, mid: string, cart, merchantInfoObj;
const createBody = (data?, mid?) => {
  let isCommaSeparatedData = ['eey3k3mkrg55tcs', '4bzi40ahksbqurl7', '19g6hlnjz9lmk'].includes(mid);
  let productsObj = {
    Tag: 'GoKwik',
    Products: commonAnalyticsData?.products,
    'Product ID': commonAnalyticsData.pidArr,
    'Product Name': commonAnalyticsData.product_name_array,
    'Product Quantity': commonAnalyticsData.products.map((a) => a['Product Quantity']),
    'Product Variant ID': commonAnalyticsData.products.map((a) => a['Product Variant Id']),
    'Variant ID': commonAnalyticsData.products.map((a) => a['Product Variant Id']),
    'Variation ID': commonAnalyticsData.products.map((a) => a['Product Variant Id']),
    'Product Price': commonAnalyticsData.products.map((a) => a['Product Price']),
    'Image URL': commonAnalyticsData.imgUrlArr,
    'Product Url': commonAnalyticsData.products.map((a) => a['Product Url']),
    'Vendor Name': cart?.items.map((item) => item['vendor']),
    Currency: commonAnalyticsData?.currency,
    'Promo Code': commonAnalyticsData?.coupon || '',
    'Cart Total Price': commonAnalyticsData?.cart_after_discount,
    channel: merchantInfoObj?.platform ? merchantInfoObj.platform : 'web',
  };
  if (isCommaSeparatedData) {
    for (const [key, value] of Object.entries(productsObj)) {
      if (Array.isArray(value) && key !== 'Products') {
        productsObj[key] = value.join(',');
      }
    }
  }
  return { ...productsObj, ...commonAnalyticsData?.marketingData, ...data };
};

export const callMoengage = (eventName, data, m_id: string, merchantInfo: any) => {
  data.commonAnalyticsData && (commonAnalyticsData = data.commonAnalyticsData);
  data.cart && (cart = data.cart);
  mid = m_id;
  data.phoneNumber = phoneFormatter(data.phoneNumber, data.analyticsPixelObj?.moengage);
  merchantInfoObj = merchantInfo;
  if (eventName == 'paymentMethod') {
    moengagePaymentMethod(data);
  } else if (eventName == 'paymentCompleted') {
    moengagePaymentCompleted(data, 'Payment_Complete_GK');
    moengagePaymentCompleted(data, 'Order Success');
    moengagePaymentCompleted(data, 'Order placed');
    moengagePaymentCompleted(data, 'Order Completed');
  } else if (eventName == 'userAddress') {
    moengageUserAddress(data);
  } else if (eventName == 'createUserAddress') {
    moengadeCreateUserAddress(data);
  } else if (eventName == 'startedCheckout') {
    moengageStartedCheckout(data);
  } else if (eventName == 'pincodeAdded') {
    moengagePincodeAdded(data);
  } else if (eventName == 'mobileAdded') {
    moengageMobileAdded(data);
  } else if (eventName === 'coupon_applied_success_gk' || eventName === 'coupon_applied_failed_gk') {
    moengageDiscountEvent(eventName, data);
  }
};

const moengageDiscountEvent = (eventName, data) => {
  let credentials = {
    eventName: eventName,
    data: createBody({
      'Promo Code': data?.evt?.coupon_code,
      'Mobile Number': data.phoneNumber,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'ABC Url': data.abcURL,
      amount_saved: !isNaN(parseFloat(data.evt.amount_saved)) ? parseFloat(data.evt.amount_saved) : 0,
      checkout_step: data?.evt?.checkout_step?.split(' ')[0].trim() || '',
    }),
  };

  fireEvents(credentials, data, eventName);
};

const moengageStartedCheckout = (data) => {
  let credentials = {
    eventName: 'Started_Checkout_GK',
    data: createBody(),
  };

  fireEvents(credentials, data, 'startedCheckout');
};

const moengagePincodeAdded = (data) => {
  let credentials = {
    eventName: 'PIN_Code_Added_GK',
    data: createBody({
      Pincode: data.evt.pincode,
      ZIP: data.evt.pincode,
      'Mobile Number': data.phoneNumber,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Country: 'India',
      'Address Type': data.userAddress?.addresstype,
      'Shipping Method': data.shippingMethod || 'Standard',
      Region: data.userAddress?.city,
    }),
  };
  fireEvents(credentials, data, 'pincodeAdded');
};

const moengageMobileAdded = (data) => {
  let credentials = {
    eventName: 'Mobile_Added_GK',
    data: {
      'Mobile Number': data.phoneNumber,
      'ABC Url': data.abcURL,
      ABC_sms: data.abcURL + `&ch=moeng&src=sms`,
      ABC_mail: data.abcURL + `&ch=moeng&src=mail`,
      ABC_wa: data.abcURL + `&ch=moeng&src=wa`,
      ABC_limechat: data.abcURL + `&ch=moeng&src=limechat`,
      ABC_zoko: data.abcURL + `&ch=moeng&src=zoko`,
      ABC_gupshup: data.abcURL + `&ch=moeng&src=gupshup`,
      ...createBody(),
    },
  };
  fireEvents(credentials, data, 'mobileAdded');
};

const moengagePaymentMethod = (data) => {
  let credentials = {
    eventName: 'Payment_Method_Selected_GK',
    data: createBody({
      'Mobile Number': data.phoneNumber,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Pincode: data.userAddress?.pincode,
      Region: data.userAddress?.city,
      Country: 'India',
      'Shipping Method': data.shippingMethod || 'Standard',
      'Payment method': data.evt.paymentMethod,
      'Address Type': data.userAddress?.addresstype,
    }),
  };

  fireEvents(credentials, data, 'paymentMethod');
};

const moengagePaymentCompleted = (data, eventName) => {
  let credentials = {
    eventName,
    data: createBody(
      {
        'Payment Complete': '',
        Token: data.token,
        'Mobile Number': data.phoneNumber,
        'First Name': data.userAddress?.firstname,
        'Last Name': data.userAddress?.lastname,
        Email: data.userAddress?.email,
        'Full Address': data.userAddress?.address,
        'Address Type': data.userAddress?.addresstype,
        City: data.userAddress?.city,
        State: data.userAddress?.state,
        Region: data.userAddress?.city,
        Pincode: data.pincode,
        Country: 'India',
        'Shipping Method': data.shippingMethod || 'Standard',
        'Payment Method': data.paymentMethod,
        Source: 'Gokwik',
        order_number: data?.orderName,
        ...data.orderPriceBreakup,
      },
      mid
    ),
  };
  fireEvents(credentials, data, 'paymentCompleted');
};

const moengageUserAddress = (data) => {
  let credentials = {
    eventName: 'Address_Selected_GK',
    data: {
      'Mobile Number': data.phoneNumber,
      'Full Name': data.userAddress?.firstname + data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Country: 'India',
      Region: data.userAddress?.city,
      'Shipping Method': data.shippingMethod || 'Standard',
      Pincode: data.userAddress?.pincode,
      'ABC Url': data.abcUrl,
      'ABC ID': `?mrid=${data?.commonAnalyticsData?.request_id}`,
      ABC_sms: data.abcUrl + `&ch=moeng&src=sms`,
      ABC_mail: data.abcUrl + `&ch=moeng&src=mail`,
      ABC_wa: data.abcUrl + `&ch=moeng&src=wa`,
      ABC_limechat: data.abcUrl + `&ch=moeng&src=limechat`,
      ABC_zoko: data.abcUrl + `&ch=moeng&src=zoko`,
      ABC_gupshup: data.abcUrl + `&ch=moeng&src=gupshup`,
      'Address Type': data.userAddress?.addresstype,
      ...createBody(),
    },
  };
  fireEvents(credentials, data, 'userAddress');
  moengageAddressCompletedEvent(credentials, data);
};

const moengadeCreateUserAddress = (data) => {
  let credentials = {
    eventName: 'Address_Added_GK',
    data: {
      'Mobile Number': data.phoneNumber,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Address 1': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Region: data.userAddress?.city,
      Country: 'India',
      'Shipping Method': data.shippingMethod || 'Standard',
      Pincode: data.userAddress?.pincode,
      'ABC Url': data.abcUrl,
      'ABC ID': `?mrid=${data?.commonAnalyticsData?.request_id}`,
      ABC_sms: data.abcUrl + `&ch=moeng&src=sms`,
      ABC_mail: data.abcUrl + `&ch=moeng&src=mail`,
      ABC_wa: data.abcUrl + `&ch=moeng&src=wa`,
      ABC_limechat: data.abcUrl + `&ch=moeng&src=limechat`,
      ABC_zoko: data.abcUrl + `&ch=moeng&src=zoko`,
      ABC_gupshup: data.abcUrl + `&ch=moeng&src=gupshup`,
      ...createBody(),
    },
  };
  fireEvents(credentials, data, 'createUserAddress');
  moengageAddressCompletedEvent(credentials, data);
};

const moengageAddressCompletedEvent = (credentials, data) => {
  credentials.eventName = 'Address_Complete_GK';
  Moengage.track_event(credentials.eventName, credentials.data);
};

const fireEvents = (credentials, data, eventName) => {
  const pixelIdentifier = data?.analyticsPixelObj?.moengage?.value;
  if (credentials?.data?.Email) {
    credentials.data.Email = credentials.data.Email.toLowerCase();
  }
  switch (eventName) {
    case 'startedCheckout':
      if (pixelIdentifier === 'phone') {
        Moengage.add_unique_user_id(data.phoneNumber);
      }
      Moengage.track_event(credentials.eventName, credentials.data);
      break;
    case 'pincodeAdded':
      Moengage.track_event(credentials.eventName, credentials.data);
      break;
    case 'mobileAdded':
      if (pixelIdentifier === 'phone') {
        Moengage.add_unique_user_id(data.phoneNumber);
      }
      Moengage.add_mobile(data.phoneNumber);
      Moengage.track_event(credentials.eventName, credentials.data);
      break;
    case 'paymentMethod':
      if (pixelIdentifier === 'customer_id' && data?.shopifyCustomerId) {
        Moengage.add_unique_user_id(data?.shopifyCustomerId);
      }
      Moengage.track_event(credentials.eventName, credentials.data);
      break;
    case 'paymentCompleted':
      if (pixelIdentifier === 'customer_id' && data?.shopifyCustomerId) {
        Moengage.add_unique_user_id(data?.shopifyCustomerId);
      }
      Moengage.track_event(credentials.eventName, credentials.data);
      break;
    case 'userAddress':
      if (pixelIdentifier === 'email') {
        Moengage.add_unique_user_id(data.userAddress?.email?.toLowerCase());
      }
      Moengage.add_first_name(data.userAddress?.firstname);
      Moengage.add_last_name(data.userAddress?.lastname);
      Moengage.add_email(data.userAddress?.email);
      Moengage.add_mobile(data.phoneNumber);
      Moengage.add_user_name(data.userAddress?.firstname + data.userAddress?.lastname); // Full name for user
      Moengage.track_event(credentials.eventName, credentials.data);
      break;
    case 'createUserAddress':
      if (pixelIdentifier === 'email') {
        Moengage.add_unique_user_id(data.userAddress?.email?.toLowerCase());
      }
      Moengage.add_first_name(data.userAddress?.firstname);
      Moengage.add_last_name(data.userAddress?.lastname);
      Moengage.add_email(data.userAddress?.email);
      Moengage.add_mobile(data.phoneNumber);
      Moengage.add_user_name(data.userAddress?.firstname + data.userAddress?.lastname); // Full name for user
      Moengage.track_event(credentials.eventName, credentials.data);
      break;
    case 'coupon_applied_success_gk':
      Moengage.track_event(credentials.eventName, credentials.data);
      break;
    case 'coupon_applied_failed_gk':
      Moengage.track_event(credentials.eventName, credentials.data);
      break;
    default:
      break;
  }
};
